import MainDetail from "./MainDetail.Component";

export default MainDetail;
